import '../../styles/solutions.css';

export interface SolutionOverviewTagProps {
  /**
   * Tag label
   */
  label: string;
}

export const SolutionOverviewTag = ({ label }: SolutionOverviewTagProps) => (
  <span className="solutions-overview-tag">{label}</span>
);
